import React from "react"
import Typing from "react-typing-animation"
// import 'jquery/dist/jquery.min.js'
// import 'popper.js/dist/popper.min'
// import 'bootstrap/dist/js/bootstrap.min.js'
import { Card,Button } from 'react-bootstrap';
import { useStaticQuery, graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import BlogList from "../components/BlogList/BlogList"

const CaseStudiesPage = () => {
  const data = useStaticQuery(graphql`
    query indexPostQuery2 {
      allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
        edges {
          node {
            frontmatter {
              title
              date(formatString: "MMM DD")
              path
              description
              image
              imagedescription
            }
          }
        }
      }
    }
  `)

  return (
    <Layout>
      <SEO
        title="Blog"
        description="Read the latest news on our company and the innovations that our team are making"
      />
    <div className="hero-section d-section">
      <div className="hero-wrapper other">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-h1">Case Studies</h1>
            <p className="hero-p">
            Find out how Cognetiks Consulting has helped organisations like yours on their Cloud and DevOps journey.
            </p>
          </div>
          <div className="hero-content"></div>
        </div>
      </div>
    </div>
    <div className="section blog-list-section pt-3 mt-5 border-bottom-0">
        <div className="container">
          <div className="row">
            <div class="col-lg-6 mt-3">
                <div class="case card" >
                    <div class="card-head m-auto">
                        <img src="/images/clients/smartct.png" class="card-img-top" height="80" alt="..."/>
                    </div>
                    <div class="card-body">
                        <h5 class="card-title">Smart CT</h5>
                        <p class="card-text">This document presents a case study highlighting the work done with Smart CT by Cognetiks Consulting.</p>
                        <a href="/case-studies/smartct" class="btn btn-outline-primary">Read More</a>
                    </div>
                    <div class="case_line"></div>
                </div>
            </div>
            <div class="col-lg-6 mt-3 ">
                <div class="case card" >
                    <div class="card-head m-auto">
                    <img src="images/clients/adimo.png" class="card-img-top" height="80"  alt="..."/>
                    </div>
                    <div class="card-body">
                        <h5 class="card-title">Adimo</h5>
                        <p class="card-text">Revolutionizing IT Infrastructure for Adimo's Shoppable Marketing Platform.</p>
                        <a href="/case-studies/adimo" class="btn btn-outline-primary">Read More</a>
                    </div>
                <div class="case_line"></div>
                </div>
            </div>
          </div>
          <div className="row">
            <div class="col-lg-6 mt-3">
                <div class="case card" >
                    <div class="card-head m-auto">
                        <img src="/images/clients/megger_Logo.png" class="card-img-top" height="80" alt="..."/>
                    </div>
                    <div class="card-body">
                        {/* <h5 class="card-title">Megger</h5> */}
                        <p class="card-text">This document presents a case study highlighting the work done with Megger by Cognetiks Consulting.</p>
                        <a href="/case-studies/megger" class="btn btn-outline-primary">Read More</a>
                    </div>
                    <div class="case_line"></div>
                </div>
            </div>
            <div class="col-lg-6 mt-3 ">
                <div class="case card" >
                    <div class="card-head m-auto">
                    <img src="images/clients/NHS_logo.png" class="card-img-top" height="80"  alt="..."/>
                    </div>
                    <div class="card-body">
                        {/* <h5 class="card-title">NHS</h5> */}
                        <p class="card-text">Streamlining Authentication and Authorization with a Secure Serverless Application.</p>
                        <a href="/case-studies/nhs" class="btn btn-outline-primary">Read More</a>
                    </div>
                <div class="case_line"></div>
                </div>
            </div>
          </div>
          <div className="row">
            <div class="col-lg-6 mt-3">
                <div class="case card" >
                    <div class="card-head m-auto">
                        <img src="/images/clients/Chetwood_Financial_logo.png" class="card-img-top" height="80" alt="..."/>
                    </div>
                    <div class="card-body">
                        {/* <h5 class="card-title">Megger</h5> */}
                        <p class="card-text">Revolutionizing Financial Decision-making: A Case Study on Chetwood Financial.</p>
                        <a href="/case-studies/cheetwood" class="btn btn-outline-primary">Read More</a>
                    </div>
                    <div class="case_line"></div>
                </div>
            </div>
            <div class="col-lg-6 mt-3 ">
                <div class="case card" >
                    <div class="card-head m-auto">
                    <img src="images/clients/Roche_logo.png" class="card-img-top" height="80"  alt="..."/>
                    </div>
                    <div class="card-body">
                        {/* <h5 class="card-title">Adimo</h5> */}
                        <p class="card-text">Orchestrating Secure and Reliable Microservices for Roche with Amazon EKS and GitOps.</p>
                        <a href="/case-studies/roche" class="btn btn-outline-primary">Read More</a>
                    </div>
                <div class="case_line"></div>
                </div>
            </div>
          </div>

          <div className="row">
            <div class="col-lg-6 mt-3">
                <div class="case card" >
                    <div class="card-head m-auto">
                        <img src="/images/clients/Rainbirdlogo.png" class="card-img-top" height="80" alt="..."/>
                    </div>
                    <div class="card-body">
                        {/* <h5 class="card-title">Megger</h5> */}
                        <p class="card-text">Seamless AI Integration: Amazon EKS Deployment for Rainbird's Decision Platform</p>
                        <a href="/case-studies/rainbird" class="btn btn-outline-primary">Read More</a>
                    </div>
                    <div class="case_line"></div>
                </div>
            </div>
            <div class="col-lg-6 mt-3 ">
                <div class="case card" >
                    <div class="card-head m-auto">
                    <img src="images/clients/avon.png" class="card-img-top" height="80"  alt="..."/>
                    </div>
                    <div class="card-body">
                        {/* <h5 class="card-title">Adimo</h5> */}
                        <p class="card-text">Avon Empowers Global Transformation with Cognetiks' AWS Expertise.</p>
                        <a href="/case-studies/avon" class="btn btn-outline-primary">Read More</a>
                    </div>
                <div class="case_line"></div>
                </div>
            </div>
            
          </div>
          
        </div>
    </div>
    </Layout>
  )
}

export default CaseStudiesPage
